import { render, staticRenderFns } from "./ListDatasourceAccessRequestedGDS.vue?vue&type=template&id=4f30ee0c&lang=pug"
import script from "./ListDatasourceAccessRequestedGDS.vue?vue&type=script&lang=js"
export * from "./ListDatasourceAccessRequestedGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f30ee0c')) {
      api.createRecord('4f30ee0c', component.options)
    } else {
      api.reload('4f30ee0c', component.options)
    }
    module.hot.accept("./ListDatasourceAccessRequestedGDS.vue?vue&type=template&id=4f30ee0c&lang=pug", function () {
      api.rerender('4f30ee0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/ListDatasourceAccessRequestedGDS.vue"
export default component.exports